import React from 'react';
import { AdminNotice } from '../../shared/components/admin/AdminPage';
import logoDark from '../../shared/img/logo/logo_dark.png';
import logoLight from '../../shared/img/logo/logo_light.png';

const Login = ({ error = '', loading = false, onLogin }) => {
  return (
    <div className="account account--not-photo admin-login">
      <div className="admin-login__card">
        <div className="admin-login__brand" role="img" aria-label="끄투리오">
          <img className="admin-login__logo admin-login__logo--light" src={logoLight} alt="" aria-hidden="true"/>
          <img className="admin-login__logo admin-login__logo--dark" src={logoDark} alt="" aria-hidden="true"/>
        </div>
        <div className="admin-login__heading">
          <h1>관리자 도구</h1>
            <p>오늘도 끄투리오를 이용해 주셔서 감사합니다.</p>
        </div>

        <AdminNotice tone={error ? 'danger' : 'info'}>
          {error ? <><strong>명령 처리 도중 오류가 발생하였습니다.</strong><br/>{error}</> : (loading
            ? '로그인 세션을 확인하고 있습니다.'
            : '끄투리오 계정으로 로그인하신 뒤 이용해 주세요.')}
        </AdminNotice>

        {loading ? (
          <div className="admin-login__loading" role="status"><span/>세션 확인 중…</div>
        ) : (
          <button type="button" className="btn btn-primary admin-login__button" onClick={onLogin}>
            끄투리오 계정으로 로그인
          </button>
        )}
        <p className="admin-login__help">v2.0.0b</p>
      </div>
    </div>
  );
};

export default Login;
